import React, {SyntheticEvent, useEffect, useState} from 'react';

type Props = {
    icon            : string
    selectedIcon    : string
    value           : boolean
    onClick         : callback
}

export default function ToggleButton(props: Props) {

    const [selected, setSelected] = useState(props.value)

    useEffect(() => {
        setSelected(props.value)
    }, [props.value])

    const classes = Classes("ui5-toggle-button", "size-22", {
        "selected": selected
    })

    const onToggle = (e: SyntheticEvent)=> {

        e.stopPropagation()

        setSelected(!selected)
        props.onClick(!selected)
    }

    const iconClass = selected ? props.selectedIcon : props.icon

    return (
        <div className={classes} onClick={onToggle}>

            <div className={Classes("icon", iconClass)}/>

        </div>
    );
}
